module.exports = __webpack_public_path__ + "img/LB.ed7ed52d.svg";